export const SITE = {
  name: "Prairie Cleanout Services",
  shortName: "Prairie Cleanout",
  tagline: "We Load It. We Haul It. We Clean It.",
  subTagline: "One Call. We Handle It All!",
  promise: "Honest Pricing. Hard Work. A Clean Space. Every Time.",
  location: "Edmonton, Alberta",
  email: "prairiecleanoutservices@gmail.com",
  facebook: "Prairie Cleanout Services",
  contacts: [
    { name: "Dan", phone: "780-394-0406", tel: "+17803940406" },
    { name: "Steve", phone: "587-991-9921", tel: "+15879919921" },
  ],
  hours: "Mon – Sun: 9:00 AM – 5:00 PM",
  hoursNote: "Closed on major holidays",
  serviceAreas: ["Edmonton", "St. Albert", "Sherwood Park", "Spruce Grove", "Leduc", "Beaumont", "Fort Saskatchewan"],
  serviceRadiusNote: "Serving Edmonton & surrounding areas within ~50 km",
};

export const FEATURES = [
  { icon: "Clock", title: "Same-Day & Next-Day Service" },
  { icon: "Users", title: "All Labour Included" },
  { icon: "Sparkles", title: "Cleanup Included" },
  { icon: "Recycle", title: "Eco-Friendly Disposal & Recycling" },
];

export const WE_REMOVE = [
  "Furniture", "Appliances", "Renovation Debris", "Yard Waste",
  "Electronics", "Scrap Metal", "Office Furniture", "Estate Contents",
  "Rental Property Junk", "Construction Debris", "Garage & Basement Clutter", "And much more!",
];

export const SERVICES = [
  {
    icon: "Home",
    title: "Residential Cleanouts",
    desc: "From garages and basements to whole-house cleanouts, we make your space clean and stress-free.",
  },
  {
    icon: "Building2",
    title: "Commercial Cleanouts",
    desc: "Offices, retail spaces, warehouses and more. We work around your schedule to minimize disruption.",
  },
  {
    icon: "HeartHandshake",
    title: "Estate Cleanouts",
    desc: "Compassionate, respectful service during difficult times. We handle everything with care.",
  },
  {
    icon: "Hammer",
    title: "Demolition & Removal",
    desc: "Sheds, decks, fences, hot tubs, cabinets and more—safely removed and hauled away.",
  },
  {
    icon: "Trees",
    title: "Yard & Property Cleanup",
    desc: "Yard waste, brush, scrap metal, and outdoor clutter cleared from any property.",
  },
  {
    icon: "PackageOpen",
    title: "Single-Item Pickups",
    desc: "Just one bulky item? Couches, appliances, mattresses—we'll haul it away fast.",
  },
];

export const WHY_US = [
  { icon: "BadgeDollarSign", title: "All-Inclusive Pricing", desc: "No hidden fees. Labour, loading, hauling, disposal and cleanup are all included." },
  { icon: "Zap", title: "Same & Next-Day Service", desc: "We show up fast, work efficiently, and leave your property swept and ready." },
  { icon: "Recycle", title: "Eco-Friendly Disposal", desc: "We donate, recycle, and dispose responsibly so less ends up in the landfill." },
];

export const CUBE_VAN_PRICING = [
  { size: "Single Small Item", desc: "", price: "$89" },
  { size: "1/8 Load", desc: "approx. 2 ft³", price: "$149" },
  { size: "1/4 Load", desc: "approx. 4 ft³", price: "$249" },
  { size: "1/2 Load", desc: "approx. 8 ft³", price: "$399" },
  { size: "3/4 Load", desc: "approx. 12 ft³", price: "$549" },
  { size: "Full Cube Van Load", desc: "approx. 16 ft³", price: "$749", highlight: true },
];

export const LOAD_INCLUDES = ["Labour", "Loading", "Hauling", "Disposal", "Sweeping cleanup", "Travel within Edmonton area"];

export const ITEM_PRICING = [
  { item: "Interior Door Removal", price: "$20 each" },
  { item: "Exterior Door Removal", price: "$20 each" },
  { item: "Handrail Removal", price: "$20 each" },
  { item: "Toilet", price: "$25" },
  { item: "Couch", price: "$50" },
  { item: "Loveseat", price: "$75" },
  { item: "Recliner", price: "$60" },
  { item: "Dining Table", price: "$60" },
  { item: "Dresser", price: "$75" },
  { item: "Washer", price: "$85" },
  { item: "Dryer", price: "$85" },
  { item: "Stove", price: "$85" },
  { item: "Dishwasher", price: "$65" },
  { item: "Barbecue", price: "$60" },
  { item: "Exercise Equipment", price: "$75+" },
];

export const DISPOSAL_FEES = [
  { item: "Mattress", price: "+$40 each" },
  { item: "Box Spring", price: "+$25 each" },
  { item: "Sleeper Sofa", price: "+$40" },
  { item: "Fridge", price: "+$35" },
  { item: "Freezer", price: "+$35" },
  { item: "Air Conditioner", price: "+$35" },
  { item: "Tire", price: "+$15 each" },
  { item: "Car Battery", price: "+$15" },
];

export const DEMOLITION = [
  { item: "Shed Removal", price: "Starting at $250" },
  { item: "Deck Removal", price: "Starting at $350" },
  { item: "Fence Removal", price: "$8–$12 per linear ft" },
  { item: "Carpet Removal", price: "$1.50 / sq ft" },
  { item: "Cabinet Removal", price: "Starting at $150" },
  { item: "Hot Tub Removal", price: "Starting at $350" },
  { item: "Play Structure Removal", price: "Starting at $250" },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1759355787121-eaef014a501d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMGhvbWUlMjB5YXJkfGVufDB8fHx8MTc4MTYzOTQwOHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1630699375895-fe5996d163ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGVtcHR5JTIwcm9vbXxlbnwwfHx8fDE3ODE2Mzk0MzJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1630699376106-d550afb865bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMGVtcHR5JTIwcm9vbXxlbnwwfHx8fDE3ODE2Mzk0MzJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/3284980/pexels-photo-3284980.png",
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1762810981576-1b07f76af9d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMGhvbWUlMjB5YXJkfGVufDB8fHx8MTc4MTYzOTQwOHww&ixlib=rb-4.1.0&q=85";

export const SERVICES_BG =
  "https://images.unsplash.com/photo-1695326612773-1243e40c18dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxsYW5kc2NhcGluZyUyMHRydWNrfGVufDB8fHx8MTc4MTYzOTQwOHww&ixlib=rb-4.1.0&q=85";
